import PropTypes from 'prop-types';
import React from 'react';
import { actionOnKeyboardPress } from '../utils/browserUtils';

/**
 * Basic button with arbitrary shape which is defined as
 * React class, e.g. SVG image.
 */
export default class ShapedButton extends React.Component {
    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
        this.keyDown = this.keyDown.bind(this);
    }

    buttonClick() {
        if (this.props.isEnabled) {
            this.props.onClick();
        }
    }

    keyDown = (e) => {
        if (this.props.isEnabled) {
            actionOnKeyboardPress(e, () => {
                this.props.onClick();
            });
        }

    }

    render() {
        return (
            <div
                aria-label={this.props.ariaLabel}
                className={this.props.styles}
                onClick={this.buttonClick}
                onKeyDown={this.keyDown}
                role="button"
                tabIndex={!this.props.isEnabled ? "-1" : this.props.customTabIndex}
            >
                {this.props.children}
                {this.props.text !== '' && (
                    <div
                        className="button-text"
                        aria-hidden={true}>
                        {this.props.text}
                    </div>
                )}
            </div>
        );
    }
}

ShapedButton.propTypes = {
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
    text: PropTypes.string,
    styles: PropTypes.string,
    isEnabled: PropTypes.bool,
    customTabIndex: PropTypes.string
};

ShapedButton.defaultProps = {
    ariaLabel: '',
    children: undefined,
    text: '',
    styles: '',
    isEnabled: true,
    customTabIndex: '0'
};
